export default "__VITE_ASSET__QIDGCJ7F__"